import * as React from 'react';
import { useEffect, useReducer } from 'react';

import { Modal, ModalBody, ModalFooter, Button, Row, Col } from 'reactstrap';

import { ShoppingCartItem } from '../../models/ShoppingCart';
import { ProductInventoryInfo, PartnerStockRow } from '../../models/Product';

import CartService from '../../services/CartService';
import { GetQuantityResult } from '../../services/ProductInventoryService';

import * as AuthorizationStore from '../../store/Authorization';

import { buildMailTo } from '../ProductSearch/ProductMailHelper';

type State = {
    approvedBy: string;
}

const initialState: State = {
    approvedBy: ''
}

function ApproveProductCardInfoModal(props: {
    cartItem: ShoppingCartItem,
    unitsToApprove: number,
    open: boolean,
    productQuantity: GetQuantityResult,
    onCancel: () => void,
    onAdd: (approvedBy: string) => void
}) {

    let [state, setState] = useReducer(
        (prevState: State, newState: Partial<State>) => ({ ...prevState, ...newState }),
        initialState
    );

    const cancel = () => {
        setState({ approvedBy: '' });

        props.onCancel();
    }

    return <>
        {props.cartItem &&
            <Modal backdrop={'static'} isOpen={props.open} toggle={cancel} size="md" className="modal-dialog-centered">
                <div className="modal-header">
                    <h5 className="modal-title">Approve</h5>
                    <button type="button"
                        className="close"
                        aria-label="Close"
                        onClick={cancel}>
                        <span aria-hidden="true"><i className="fa fa-times"></i></span>
                    </button>
                </div>

                <ModalBody>
                    <div className="form-group">
                        <label>PRODUCT</label>
                        <span className="form-control-plaintext">{props.cartItem.ProductNumber}</span>
                    </div>
                    <hr />

                    <div className="text-center">
                        <div><i className="fa fa-question-circle fa-3x color-orange"></i></div>
                        <div className="lead"><span>Some of the quantity you've selected ({props.unitsToApprove}) requires call for approval</span></div>
                        <hr />
                        <div className="partner-name text-nowrap">{props.cartItem.PartnerStock.PriceAvailabilityContactName}</div>
                        <div><a href={buildMailTo(props.cartItem.PartnerStock, props.cartItem.Inventory, props.productQuantity)} className="text-nowrap">{props.cartItem.PartnerStock.PriceAvailabilityContactEmail}</a></div>
                        <div className="text-nowrap">
                            <a href={'tel:' + props.cartItem.PartnerStock.PriceAvailabilityContactPhone} className="text-nowrap">{props.cartItem.PartnerStock.PriceAvailabilityContactPhone}</a>
                        </div>
                    </div>

                </ModalBody>
                <ModalFooter>
                    <Row className="w-100">
                        <Col md={7} className="p-0">
                            <div className="form-group m-0">
                                <label className="text-nowrap">Who Approved The Purchase?</label>
                                <input className="form-control" value={state.approvedBy} onChange={(e) => setState({ approvedBy: e.target.value })} />
                            </div>
                        </Col>
                        <Col md={5} className="pr-0">
                            <div className="form-group m-0">
                                <label>&nbsp;</label>
                                <Button color="black" className="w-100" onClick={() => {
                                    props.onAdd(state.approvedBy);
                                    setState({ approvedBy: '' });
                                }} disabled={state.approvedBy.length === 0}>Approved</Button>
                            </div>
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>}
    </>

}

export default ApproveProductCardInfoModal;
